import React from 'react';

// Formulario de edición de un turno (fecha/hora/duración/notas), compartido
// entre Calendario.jsx y PendientesDelDia.jsx. Para un evento genérico
// (turno.patient == null) también edita el título (Appointment.title) — para
// un turno de paciente, el lápiz junto al nombre abre el flujo de renombrar
// paciente aparte (onRenombrarPaciente), no un campo de este formulario: el
// nombre no es una etiqueta local del turno.
function EditarTurnoModal({
  turno, fecha, setFecha, hora, setHora, duracion, setDuracion, notas, setNotas,
  titulo, setTitulo, guardando, onGuardar, onCerrar, onRenombrarPaciente,
}) {
  return (
    <div className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onCerrar(); }}>
      <div className="modal-card modal-card-sm">
        <div className="modal-header">
          <h3>
            Editar turno — {turno.patient_name}
            {turno.patient && onRenombrarPaciente && (
              <button
                type="button"
                className="edit-turno-btn-renombrar"
                onClick={() => onRenombrarPaciente(turno)}
                title="Renombrar paciente"
                aria-label="Renombrar paciente"
              >
                ✏️
              </button>
            )}
          </h3>
          <button className="modal-btn-cerrar" onClick={onCerrar}>✕</button>
        </div>
        <div className="modal-body">
          <div className="edit-turno-grid">
            {!turno.patient && (
              <label className="edit-turno-label edit-turno-full">
                Título
                <input type="text" className="edit-turno-input" value={titulo} onChange={e => setTitulo(e.target.value)} placeholder="Título del evento" />
              </label>
            )}
            <label className="edit-turno-label">
              Fecha
              <input type="date" className="edit-turno-input" value={fecha} onChange={e => setFecha(e.target.value)} />
            </label>
            <label className="edit-turno-label">
              Hora
              <input type="time" className="edit-turno-input" value={hora} onChange={e => setHora(e.target.value)} />
            </label>
            <label className="edit-turno-label">
              Duración (min)
              <input type="number" className="edit-turno-input" value={duracion} onChange={e => setDuracion(e.target.value)} min={15} max={480} />
            </label>
            <label className="edit-turno-label edit-turno-full">
              Notas
              <input type="text" className="edit-turno-input" value={notas} onChange={e => setNotas(e.target.value)} placeholder="Notas (opcional)" />
            </label>
          </div>
        </div>
        <div className="modal-acciones">
          <button className="modal-btn-cancelar" onClick={onCerrar}>Cancelar</button>
          <button className="modal-btn-guardar" onClick={onGuardar} disabled={guardando}>
            {guardando ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditarTurnoModal;
